import styled, { keyframes } from 'styled-components'
import { Link } from 'gatsby'
import { breakpoints } from '../../styles/global'


export const PageWrapper = styled.div`
  height: 100vh;
  width: 100%;
  background: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
`

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`
export const VideoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 660px;
  margin: auto;
  animation: ${fadeIn} 2.75s;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 75px;


  @media (min-width: ${breakpoints.min.desktop}px) {
    padding-bottom: 75px;
  }

  @media (min-width: ${breakpoints.min.desktopLg}px) {
    padding-bottom: 0;
  }
`


export const Video = styled.video`
  max-width: 100%;
  height: auto;
`


export const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 15px;
`

export const Button = styled(Link)`
  cursor: pointer;
  padding: 12px 24px;
  min-width: 200px;
  background: transparent;
  color: #333;
  border: 1px solid #333;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: all .5s;
  font-size: 14px;

  &:hover {
    transform: scale(1.01);
    box-shadow: 2px 2px 2px #9a9a9a2e;
  }

  &:not(:first-child) {
    margin-left: 15px;
  }
`